import { useDataChange, useDataValue } from 'Simple/Data'

export function useOnChange(props) {
  let change = useDataChange({
    viewPath: props.viewPath,
    context: 'selected',
  })

  let configurations = useDataValue({
    viewPath: props.viewPath,
    context: 'configurations',
  })

  return function onChange(value) {
    if (!value) return

    let configuration = configurations.find(config => config.id === value)

    change(next => {
      next.configuration_id = configuration.id
      next.configuration_level = configuration.organization.level
      next.configuration_organization_id = configuration.organization._id
    })
  }
}
